var _defs, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowGrayDown = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5.673,
    viewBox: "0 0 9 5.673",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.786,82.873l-.433-.433a.74.74,0,0,0-.526-.214.708.708,0,0,0-.52.214L4.5,85.247,1.693,82.44a.708.708,0,0,0-.52-.214.74.74,0,0,0-.526.214l-.427.433A.717.717,0,0,0,0,83.4a.687.687,0,0,0,.219.52L3.98,87.679a.687.687,0,0,0,.52.219.717.717,0,0,0,.526-.219l3.761-3.761A.708.708,0,0,0,9,83.4.74.74,0,0,0,8.786,82.873Z",
    transform: "translate(0 -82.226)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowGrayDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-gray-down.f32eb091.svg";
export { ForwardRef as ReactComponent };